import React, { useState } from "react"
import { Modal } from "components"
import { toast } from "react-toastify"

import { Button, CurrencyInput } from "components"
import { topupPaymentServiceOwner } from "services"
import classes from "./SpwTopupModal.module.scss"

const SpwTopupModal = props => {
  const {
    openTopupModal,
    setOpenTopupModal
  } = props

  const [input, setInput] = useState("")
  const [error, setError] = useState("")
  const [sending, setSending] = useState(false)

  const validate = () => {
    if (Number(input) < 1000) {
      setError("مقدار افزایش اعتبار باید بیشتر از 1,000 تومان باشد")

      return false
    }

    return true
  }

  const handleTopup = async () => {
    if (!validate()) return

    setSending(true)

    try {
      const { gatewayUrl } =
        await topupPaymentServiceOwner({
          type: "zarinpal",
          amount: Number(input)
        })

      window.location.href = gatewayUrl
    } catch (err) {
      console.log(err)

      toast.error("عملیات انجام نشد")

      setSending(false)
    }
  }

  return (
    <Modal
      show={openTopupModal}
      onHide={() => setOpenTopupModal(false)}
      backdrop="static"
      onExited={() => setInput("")}
      
    >
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          افزایش اعتبار
        </div>
        <CurrencyInput
          value={input}
          type="number"
          error={error}
          className={classes["input"]}
          label="مقدار افزایش اعتبار (تومان)"
          onChange={(value) => setInput(value)}
        />
        <div className={classes["footer"]}>
          <Button
            disabled={sending}
            onClick={() => setOpenTopupModal(false)}
            color="danger"
          >
            بازگشت
          </Button>
          <Button
            color="success"
            className={classes["button"]}
            loading={sending}
            onClick={handleTopup}
          >
            افزایش
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SpwTopupModal